// extracted by mini-css-extract-plugin
export default {"page":"KH9JV62H","wrapper":"NMr8SZJ9","main":"qqQaT3of","mainWrapper":"CQve3Y8u","title":"wYrwUZTq","cardsWrapper":"_0J4Rr_a6","conditionsWrapper":"oXKv_Fr9","selector":"XE61umf3","backToGameButton":"n618ChCm"};
    if(module.hot) {
      // 1721069998954
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  